import { info } from '../../features/src/i18n/locales/info';

export function getLanguage(locale: string) {
  return info[locale]?.contentful ?? info.en.contentful;
}
